import { Role } from '../model/roleType';
import { Principal } from './../../core/auth/principal.service';
export class RoleUtil {

    static readonly Role = Role;

    public static checkForAdmin(authority: any): boolean {
        return authority == Role.ROLE_ADMIN || authority == Role.ADMIN_STAFF;
    }

    public static checkForUnderwriter(authority: any): boolean {
        return authority == Role.UNDERWRITER || authority == Role.UNDERWRITER_STAFF;
    }

    public static checkForClient(authority: any): boolean {
        return authority == Role.CLIENT || authority == Role.CLIENT_STAFF;
    }

    public static checkForBroker(authority: any): boolean {
        return authority == Role.BROKER || authority == Role.BROKER_STAFF;
    }

    public static checkForInsurer(authority: any): boolean {
        return authority == Role.INSURER || authority == Role.INSURER_STAFF;
    }

    public static checkForAdminBroker(authority: any, principal: Principal): boolean {
        if ((authority == Role.BROKER || authority == Role.BROKER_STAFF) && principal.isCreatedByAdmin) {
            return true;
        } else return false;
    }


    public static isUnderwriter(role: any): boolean {
        return this.checkForUnderwriter(role);
    }

    public static isClient(role: any): boolean {
        return this.checkForClient(role);
    }

    public static isBroker(role: any): boolean {
        return this.checkForBroker(role);
    }

    public static isInsurer(role: any): boolean {
        return this.checkForInsurer(role);
    }

    public static isStaff(role: any): boolean {
        return role == Role.BROKER_STAFF || role == Role.UNDERWRITER_STAFF || role == Role.INSURER_STAFF;
    }

    public static isBrokerUnderwriterInsurer(role: any): boolean {
        return role == Role.BROKER || role == Role.BROKER_STAFF || role == Role.UNDERWRITER || role == Role.UNDERWRITER_STAFF || role == Role.INSURER || role == Role.INSURER_STAFF;

    }

    public static isBrokerUnderwriterInsurerWithAudit(role: any): boolean {
        return role == Role.BROKER || role == Role.BROKER_STAFF || role == Role.UNDERWRITER || role == Role.UNDERWRITER_STAFF || role == Role.INSURER || role == Role.INSURER_STAFF || role == Role.INSURER_AUDIT || role == Role.UNDERWRITER_AUDIT;
    }

    public static checkForAuditors(authority: any) {
        return authority == Role.INSURER_AUDIT || authority == Role.UNDERWRITER_AUDIT || authority == Role.AUDIT_USER;
    }

    public static isSpotClient(authority: any) {
        return authority == Role.SPOT_CLIENT;
    }

    public static ClientAuthorities = [Role.CLIENT, Role.CLIENT_STAFF];

    public static BrokerAuthorities = [Role.BROKER, Role.BROKER_STAFF]

    public static BrokerAuditUserAuthorities = [Role.BROKER, Role.BROKER_STAFF, Role.AUDIT_USER, Role.AUDIT_USER_STAFF]

    public static UnderwriterAuthorities = [Role.UNDERWRITER, Role.UNDERWRITER_STAFF]

    public static InsurerAuthorities = [Role.INSURER, Role.INSURER_STAFF]

    public static UnderwriteInsurerAuthorities = [Role.UNDERWRITER, Role.UNDERWRITER_STAFF, Role.INSURER, Role.INSURER_STAFF]

    public static BrokerUnderwriteInsurerAuthorities = [Role.BROKER, Role.BROKER_STAFF, Role.UNDERWRITER, Role.UNDERWRITER_STAFF, Role.INSURER, Role.INSURER_STAFF]

    public static BrokerUnderwriteInsurerWithUnInAuditAuthorities = [Role.BROKER, Role.BROKER_STAFF, Role.UNDERWRITER, Role.UNDERWRITER_STAFF, Role.INSURER, Role.INSURER_STAFF, Role.UNDERWRITER_AUDIT, Role.INSURER_AUDIT]

    public static UnderwriterInsurerAuditAuthorities = [Role.UNDERWRITER_AUDIT, Role.INSURER_AUDIT]

    public static ClientBrokerUnderwriterInsurerAuthorities = [Role.CLIENT, Role.CLIENT_STAFF, Role.BROKER, Role.BROKER_STAFF, Role.UNDERWRITER, Role.UNDERWRITER_STAFF, Role.INSURER, Role.INSURER_STAFF];

    public static ClientBrokerUnderwriterInsurerAuthoritiesWithAuditUserStaff = [Role.CLIENT, Role.CLIENT_STAFF, Role.BROKER, Role.BROKER_STAFF, Role.UNDERWRITER, Role.UNDERWRITER_STAFF, Role.INSURER, Role.INSURER_STAFF, Role.AUDIT_USER, Role.AUDIT_USER_STAFF];

    public static BrokerUnderwriterInsurerAuthoritiesWithUnderwriterInsurerAudit = [Role.BROKER, Role.BROKER_STAFF, Role.UNDERWRITER, Role.UNDERWRITER_STAFF, Role.INSURER, Role.INSURER_STAFF, Role.UNDERWRITER_AUDIT, Role.INSURER_AUDIT];

    public static ClientBrokerUnderwriterInsurerAuthoritiesWithUnderwriterInsurerAudit = [Role.CLIENT, Role.CLIENT_STAFF, Role.BROKER, Role.BROKER_STAFF, Role.UNDERWRITER, Role.UNDERWRITER_STAFF, Role.INSURER, Role.INSURER_STAFF, Role.UNDERWRITER_AUDIT, Role.INSURER_AUDIT];

    public static BrokerUnderwriterInsurerAuthoritiesWithAuditUserStaff = [Role.BROKER, Role.BROKER_STAFF, Role.UNDERWRITER, Role.UNDERWRITER_STAFF, Role.INSURER, Role.INSURER_STAFF, Role.AUDIT_USER, Role.AUDIT_USER_STAFF];

    public static BrokerUnderwriterInsurerAuditUserAuthorities = [Role.BROKER, Role.BROKER_STAFF, Role.UNDERWRITER, Role.UNDERWRITER_STAFF, Role.INSURER, Role.INSURER_STAFF, Role.AUDIT_USER];

    public static AdminBrokerUnderwriterInsurerAuthoritiesWithAuditUserStaff = [Role.ROLE_ADMIN, Role.ADMIN_STAFF, Role.BROKER, Role.BROKER_STAFF, Role.UNDERWRITER, Role.UNDERWRITER_STAFF, Role.INSURER, Role.INSURER_STAFF, Role.AUDIT_USER, Role.AUDIT_USER_STAFF];

    public static BrokerUnderwriterInsurerAuthoritiesWithUnderwriterInsurerAuditAndAuditUserStaff = [Role.BROKER, Role.BROKER_STAFF, Role.UNDERWRITER, Role.UNDERWRITER_STAFF, Role.INSURER, Role.INSURER_STAFF, Role.UNDERWRITER_AUDIT, Role.INSURER_AUDIT, Role.AUDIT_USER, Role.AUDIT_USER_STAFF];

    public static AllAuthoritiesExceptSpotClient = [Role.CLIENT, Role.CLIENT_STAFF, Role.BROKER, Role.BROKER_STAFF, Role.UNDERWRITER, Role.UNDERWRITER_STAFF, Role.INSURER, Role.INSURER_STAFF, Role.UNDERWRITER_AUDIT, Role.INSURER_AUDIT, Role.AUDIT_USER, Role.AUDIT_USER_STAFF];

    public static getAllAuthorities = [Role.CLIENT, Role.CLIENT_STAFF, Role.BROKER, Role.BROKER_STAFF, Role.UNDERWRITER, Role.UNDERWRITER_STAFF, Role.INSURER, Role.INSURER_STAFF, Role.UNDERWRITER_AUDIT, Role.INSURER_AUDIT];

    public static ClientBrokerUnderwriterInsurerAuthoritiesWithSpotClient = [Role.CLIENT, Role.CLIENT_STAFF, Role.BROKER, Role.BROKER_STAFF, Role.UNDERWRITER, Role.UNDERWRITER_STAFF, Role.INSURER, Role.INSURER_STAFF, Role.SPOT_CLIENT];

    public static ClientClaimantBrokerUnderwriter = [Role.CLIENT, Role.CLIENT_STAFF, Role.CLAIMANT, Role.BROKER, Role.BROKER_STAFF, Role.UNDERWRITER, Role.UNDERWRITER_STAFF];

    public static UnderwriterInsurerAdminBrokerClientInsAuditUndAudit = [Role.UNDERWRITER, Role.UNDERWRITER_STAFF, Role.INSURER, Role.INSURER_STAFF, Role.ROLE_ADMIN, Role.ADMIN_STAFF, Role.BROKER, Role.BROKER_STAFF, Role.CLIENT, Role.CLIENT_STAFF, Role.INSURER_AUDIT, Role.UNDERWRITER_AUDIT];

    public static ClientBrokerStaff = [Role.CLIENT, Role.CLIENT_STAFF, Role.BROKER, Role.BROKER_STAFF];

    public static AdminBrokerUnderwriterInsurerAuditClientStaffAuthorities = [Role.ROLE_ADMIN, Role.ADMIN_STAFF, Role.BROKER, Role.BROKER_STAFF, Role.UNDERWRITER, Role.UNDERWRITER_STAFF, Role.INSURER, Role.INSURER_STAFF, Role.AUDIT_USER, Role.AUDIT_USER_STAFF, Role.CLIENT, Role.CLIENT_STAFF];

}
